import HighlightCarousel from 'components/Content/NavigationCarousel/HighlightCarousel/HighlightCarousel';

export default HighlightCarousel;
